import { render, staticRenderFns } from "./PortfoliosTable.vue?vue&type=template&id=705a249e&scoped=true&"
import script from "./PortfoliosTable.vue?vue&type=script&lang=js&"
export * from "./PortfoliosTable.vue?vue&type=script&lang=js&"
import style0 from "./PortfoliosTable.vue?vue&type=style&index=0&id=705a249e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705a249e",
  null
  
)

export default component.exports